<template>
  <el-row>
    <el-table :data="userGuideList" border style="width: 60%">
      <el-table-column prop="name" label="设备型号" width="120">
      </el-table-column>
      <el-table-column prop="note" label="描述" width="180"> </el-table-column>
      <el-table-column :label="$t('m.table.operation')">
        <template slot-scope="scope">
          <el-button type="primary" @click="downloadFile(scope.row)">
            下载手册</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <a ref="downTarget" style="display: none" href="" target="_blank"></a>
  </el-row>
</template>

<script>
export default {
  name: "userGuide",
  data() {
    return {
      userGuideList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getUserGuide();
  },
  methods: {
    getUserGuide() {
      this.$http
        .get("/manage/deviceType/listByUser.do")
        .then(
          function(resp) {
            if (resp.data.success) {
              this.userGuideList = resp.data.data.list;
              this.page.total = resp.data.data.total;
            } else {
              this.$message.error("获取用户指南失败:" + resp.data.msg);
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    downloadFile(row) {
      let downFile = this.$refs.downTarget;
      downFile.setAttribute("href", row.file);
      downFile.click();
    },
  },
};
</script>

<style scoped></style>
